var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "modal-no-claims", centered: "", size: "lg" },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("img", {
                attrs: {
                  src: require("./../../images/sbl-logo-blue.png"),
                  alt: "Sbl Logo",
                  width: "250px"
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.closeModal }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          stroke: "#B7B7B7",
                          d:
                            "M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: { click: _vm.closeModal }
                    },
                    [_vm._v("\n                Cancel\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "submit", size: "sm", variant: "success" },
                      on: { click: _vm.confirmBid }
                    },
                    [_vm._v("\n                Confirm bid\n            ")]
                  )
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _vm._v(" "),
      _c("h5", [_vm._v("Confirmation of vehicle bid")]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
            }
          }
        },
        [
          _c("messages", { attrs: { messages: _vm.messages } }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm._v(
                "\n                By clicking 'Confirm', you acknowledge and agree to the following "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "\n                        You understand that no claims can be made on this vehicle due to the reason outlined below.\n                        "
                  ),
                  _c("br"),
                  _c("strong", { staticStyle: { color: "#2F6EBA" } }, [
                    _vm._v(_vm._s(_vm.noClaimsReason))
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "mt-4 acceptance" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "input-group-2",
                      label: "",
                      "label-for": "order_confirm",
                      "invalid-feedback": _vm.invalidField("noClaimsConfirm")
                    }
                  },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          id: "order_confirm",
                          state: _vm.fieldState("noClaimsConfirm"),
                          required: ""
                        },
                        model: {
                          value: _vm.accepted,
                          callback: function($$v) {
                            _vm.accepted = $$v
                          },
                          expression: "accepted"
                        }
                      },
                      [
                        _vm._v(
                          "\n                        You accept full responsibility for the vehicle and release SBL from any liability for current or future issues related to this reason.\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ee8744c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee8744c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NoClaimsModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4ee8744c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NoClaimsModal.vue
// module chunks = 0